import { Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import Home from './pages/Home'
import Browse from './pages/Browse'
import ImageDetail from './pages/ImageDetail'
import Search from './pages/Search'

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="images" element={<Browse />} />
        <Route path="images/:name" element={<ImageDetail />} />
        <Route path="search" element={<Search />} />
      </Route>
    </Routes>
  )
}
